const HANDLE_MODE = 'HANDLE_MODE';
export default {
  HANDLE_MODE,
};
